
//Représente les paramètres de mise à jour de la taille d’une colonne d’un utilisateur
export class ASeMettreAJourTailleColonneUtilisateurParametres 
{
  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Identifiant de la colonne
  public identifiantColonne!: string;

  //Taille de la colonne
  public taille!: number;
}
